import React, {useEffect, useState} from "react";

import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {useNavigate} from "react-router-dom";
import {PaymentGatewayService} from "../../serverService/paymentGatewayService/PaymentGatewayService";
import AddNewPaymentGateway from "../../component/addNewPaymentGateway/AddNewPaymentGateway";
import {css} from "@emotion/css";

import {
    convertUniversalDateToPersianDate,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    showErrorMessage,
    RaikoTableTitleContainer, RaikoCustomTable
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function PaymentGatewaysList() {
    let page = 0
    const size = 15;

    const service = new PaymentGatewayService()
    const navigate = useNavigate()

    const [openPaymentGatewayModal, setOpenPaymentGatewayModal] = useState(false)
    const [paymentGatewayTotal, setPaymentGatewayTotal] = useState("")

    const [gatewayList, setGatewayList] = useState([])
    const [tableLoadingState, setTableLoadingState] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDataFromServer()
        }
    }, []);


    function getDataFromServer() {
        setTableLoadingState(true)
        service.getGatewaysList(page, size)
            .then(response => {
                setGatewayList([])
                response.data.map((item, index) => {
                    setGatewayList(prevState => [
                        ...prevState,
                        preparePaymentGatewaysListRow(item, index)
                    ])
                })

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoadingState(false)
        })
    }

    function handleOpenPaymentGatewayModal() {
        setOpenPaymentGatewayModal(true)
    }

    function handleClosePaymentGatewayModal() {
        setOpenPaymentGatewayModal(false)
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function preparePaymentGatewaysListRow(item, number = 0) {
        return {
            ...item,
            number: (page * size) + number + 1,
            createdAt: convertUniversalDateToPersianDate(item.createdAt),
            enabled: <RaikoCustomSimpleActiveDeActiveChip
                deActiveStateTitle={"غیر فعال"}
                activeStateTitle={"فعال"}
                state={item.enabled ? item.enabled : false}
            />
        }
    }

    function handleShowPaymentGateways(PaymentGatewayId) {
        navigate(`${RouteHelper.PaymentGatewaysInformation.globalUrl.replace(":id", PaymentGatewayId)}`)
    }

    function addNewGateway(gatewayInfo) {
        setGatewayList(prevState => {
            const _value = []
            _value.push(preparePaymentGatewaysListRow(gatewayInfo, 0))

            prevState.map((item, index) => {
                _value.push(preparePaymentGatewaysListRow(item, item.number))
            })

            return _value
        })
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.PaymentGatewaysList.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleClosePaymentGatewayModal}
                open={openPaymentGatewayModal}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"افزودن درگاه جدید"}
            >
                <AddNewPaymentGateway
                    addNewGateway={addNewGateway}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(RouteHelper.PaymentGatewaysList.name, "")
                    ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoTableTitleContainer
                            title={"درگاه های پرداخت"}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenPaymentGatewayModal}
                            hasAmount
                            amount={paymentGatewayTotal}
                        />
                        <RaikoCustomTable
                            data={gatewayList}
                            header={paymentGatewaysTableHeader}
                            isLoading={tableLoadingState}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleShowPaymentGateways}
                        />
                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>


        </>
    )
}
export const paymentGatewaysTableHeader = [
    {
        id: "number",
        label: "#"
    }, {
        id: "title",
        label: "عنوان"
    }, {
        id: "type",
        label: "نوع"
    }, {
        id: "createdBy",
        label: "سازنده",
    }, {
        id: "createdAt",
        label: "تاریخ ساخت"
    }, {
        id: "enabled",
        label: "وضعیت"
    }
]